module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jYCUm"))).then(() => module.bundle.root('hEqeo'));